import { alpha, Theme } from "@mui/material";

export const createComponents = () => ({
  shape: {
    borderRadius: "28px",
  },
});
